import Vue from 'vue';
export default Vue.extend({
    name: 'Footer',
    props: {
        registrationInfo: {
            type: String,
            required: false
        },
        copyrightInfo: {
            type: String,
            required: false
        }
    },
    setup(props) {
        const getCopyrightInfo = () => {
            const copyright = props.copyrightInfo;
            const currentYear = new Date().getFullYear();
            if (copyright) {
                return copyright
                    .replace('{currentYear}', currentYear);
            }
            return copyright;
        };
        return {
            getCopyrightInfo
        };
    }
});
